/**
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import CookieSetting from "../cookie-setting/cookie-setting";
import {
  allCookiesOfListAccepted,
  isAtLeatOneCookiesOfListAccepted
} from "../../../../../utils/cookie-config-helper";
import { mainChannel } from "../../../../../init/message-hub";

const template = require("./template.pug");
require("./style.scss");

export default Backbone.View.extend({
  className: "cookie-container",

  events: {
    "click .toggle-list": "toggleList",
    "change .category-checkbox": "toggleCheckCategory"
  },

  listShown: false,

  cookieSettings: [],

  initialize(container, disabled) {
    this.render();
    this.initElements();
    this.initEvents();
    this.initContainer(container, disabled);
  },

  render() {
    this.$el.html(template);
  },

  initEvents() {
    mainChannel.on("configUpdated", this.reset, this);
  },

  initContainer(container, immutable) {
    this.container = container;
    this.$title.html(container.name);
    this.$description.html(container.description);
    for (let i = 0; i < container.list.length; i++) {
      const cookie = container.list[i];
      const cookieSetting = new CookieSetting(cookie, immutable);
      this.cookieSettings.push(cookieSetting);
      this.$listCookiesTable.append(cookieSetting.$el);
    }
    this.$listCookies.hide();
    if (immutable) {
      this.$categoryCheckbox.prop("disabled", true);
      this.$categoryCheckbox
        .parent()
        .find(".slider")
        .addClass("disabled");
    }
  },

  toggleList(e) {
    e.stopPropagation();
    e.preventDefault();
    if (this.listShown) {
      this.$toggleList.html(
        `${myTranslation("show_cookies").toUpperCase()} &#x27A7;`
      );
      this.$listCookies.hide();
    } else {
      this.$toggleList.html(`${myTranslation("hide_cookies").toUpperCase()}`);
      this.$listCookies.show();
    }
    this.listShown = !this.listShown;
  },

  initElements() {
    this.$title = $(this.$(".title-cook"));
    this.$description = $(this.$(".description"));
    this.$listCookies = $(this.$(".list-cookies"));
    this.$listCookiesTable = $(this.$(".list-cookies-table"));
    this.$toggleList = $(this.$(".toggle-list"));
    this.$categoryCheckbox = $(this.$(".category-checkbox"));
  },

  toggleCheckCategory(e) {
    const checked = $(e.target).is(":checked");
    console.log(this.container.name + " " + checked);
    mainChannel.request("toggleCategory", this.container, checked);
  },

  reset() {
    const allAccepted = allCookiesOfListAccepted(this.container.list);
    this.$categoryCheckbox.prop("checked", allAccepted);
    if (allAccepted || !isAtLeatOneCookiesOfListAccepted(this.container.list)) {
      this.$(".main-slider").removeClass("not-all");
    } else {
      this.$(".main-slider").addClass("not-all");
    }
    for (let i = 0; i < this.cookieSettings.length; i++) {
      this.cookieSettings[i].reset();
    }
    this.delegateEvents();
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/pages/details/partials/container/cookie-container.js